import React, { createContext, useContext, useState } from 'react';

// Créez un contexte pour le mode hors ligne
const OfflineModeContext = createContext<any>(null);

export const useOfflineMode = () => {
  return useContext(OfflineModeContext);
};

export const OfflineModeProvider = ({ children }: { children: React.ReactNode }) => {
  const [ifOffLineMode, setIsOfflineMode] = useState<boolean>(false);

  const toggleOfflineMode = () => {
    setIsOfflineMode(prevMode => !prevMode);
  };

  return (
    <OfflineModeContext.Provider value={{ ifOffLineMode, toggleOfflineMode }}>
      {children}
    </OfflineModeContext.Provider>
  );
};
